// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ql-container {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

.ql-toolbar.ql-snow{
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}


.no-border .MuiOutlinedInput-notchedOutline {
    border: none;
}

.custom-helper-text{
    font-family: Jost, sans-serif;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.66;
    text-align: left;
    margin-top: 4px;
    margin-right: 14px;
    margin-bottom: 0;
    margin-left: 14px;
    color: #d32f2f;
}

.error-border .ql-toolbar.ql-snow,
.error-border .ql-container.ql-snow {
    border-color: #d32f2f !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/workbench/contact-plan/ContactPlan.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,gCAAgC;AACpC","sourcesContent":[".ql-container {\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n\n.ql-toolbar.ql-snow{\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n}\n\n\n.no-border .MuiOutlinedInput-notchedOutline {\n    border: none;\n}\n\n.custom-helper-text{\n    font-family: Jost, sans-serif;\n    font-weight: 400;\n    font-size: 0.75rem;\n    line-height: 1.66;\n    text-align: left;\n    margin-top: 4px;\n    margin-right: 14px;\n    margin-bottom: 0;\n    margin-left: 14px;\n    color: #d32f2f;\n}\n\n.error-border .ql-toolbar.ql-snow,\n.error-border .ql-container.ql-snow {\n    border-color: #d32f2f !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
